import { t } from "@lingui/macro";
import {
  type QuoteForNavigationQuery,
  useQuoteForNavigationQuery,
} from "@src/__generated__/graphql";
import { useNavigationPages } from "@src/components/widgets/AppSubNav/hooks";
import type { NavigationHook } from "@src/components/widgets/AppSubNav/hooks/types";

export function useQuoteNavigationPages(
  quoteId: string,
): NavigationHook<QuoteForNavigationQuery["GetQuote"]> {
  const { activePage, activeSubpage, allPages, visiblePages } =
    useNavigationPages([
      {
        href: { pathname: "/budgets/quotes" },
        title: () => t`Quotes`,
      },
    ]);

  const { data, loading } = useQuoteForNavigationQuery({
    variables: {
      id: quoteId,
    },
    skip: !quoteId,
    notifyOnNetworkStatusChange: true,
    fetchPolicy: "cache-first",
  });

  return {
    activePage,
    activeSubpage,
    allPages,
    visiblePages,
    data: data?.GetQuote,
    isLoading: loading,
  };
}
